function Subtitle() {
	return (
		<p className='mx-8 mb-6 text-gray-600 xs:text-lg text-center'>
			A collection of free APIs derived from&nbsp;
			<a
				href='https://github.com/public-apis/public-apis'
				rel='noreferrer'
				target='_blank'
				className='underline hover:text-gray-500 inline-block'
			>
				Public APIs
			</a>
		</p>
	);
}

export default Subtitle;
